import { CheckIcon, LoaderCircleIcon } from "lucide-react"

import type { AutosaveState } from "@/lib/forms/useAutosaveDraft"

interface Props {
  status: AutosaveState
}

/**
 * Tells the borrower their answers are being kept, as they type them.
 *
 * Holds its height whatever it has to say, so appearing and disappearing never
 * shifts what sits beside it. There is nothing to show for a save that failed,
 * see `useAutosaveDraft`.
 */
export function AutosaveStatus({ status }: Props) {
  return (
    <p
      role="status"
      className="text-muted-foreground flex h-5 items-center gap-1.5 text-sm"
    >
      {status === "saving" && (
        <>
          <LoaderCircleIcon className="size-3.5 animate-spin" aria-hidden />
          Saving…
        </>
      )}
      {status === "saved" && (
        <>
          <CheckIcon className="size-3.5" aria-hidden />
          Saved
        </>
      )}
    </p>
  )
}
